import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LandingPageComponent } from '../contents/pages/landing-page/landing-page.component';
import { LoadingPageComponent } from '../contents/pages/loading-page/loading-page.component';
import { ContentsComponent } from './contents.component';
import { AuthGuardService } from '../services/auth/auth-guard.service';
import { ReportComponent } from '../contents/pages/report/report.component';
import { NotFoundComponent } from '../contents/pages/not-found/not-found.component';
import { GameLobbyComponent } from './pages/game-lobby/game-lobby.component';

const routes: Routes = [
    { path: '', pathMatch: 'full', redirectTo: 'pages' },
    {
        path: 'pages',
        component: ContentsComponent,
        children: [
            { path: '', pathMatch: 'full', redirectTo: 'landing-page' },
            { path: 'landing-page', component: LandingPageComponent },
        ]
    },
    {
        path: 'pages',
        children: [
            { path: 'loading-page', component: LoadingPageComponent },
        ]
    },
    {
        path: 'pages',
        children: [
            { path: 'report', component: ReportComponent },
        ]
    },
    {
        path: 'pages',
        children: [
            { path: 'game-lobby', component: GameLobbyComponent },
        ]
    },
    // Add the 404 route
    { path: '**', component: NotFoundComponent }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
    providers: [AuthGuardService]
})
export class ContentsRoutingModule { }
